import type { ComponentPropsWithoutRef, ReactNode } from "react";

/** Keep section titles and actions aligned across all sidebar modes. */
export function SidebarSectionHeader({ children, actions, className = "", ...props }: ComponentPropsWithoutRef<"div"> & { actions?: ReactNode }) {
  return <div {...props} className={`mb-1 flex h-7 shrink-0 items-center justify-between px-2 ${className}`}>
    <h2 className="text-sm font-medium text-zinc-200">{children}</h2>
    {actions && <div className="flex items-center gap-1">{actions}</div>}
  </div>;
}
